import {
    emitGlobalError,
    getApiErrorMessage,
    isCancelledRequest,
    shouldSkipApiNotify,
} from '../utils/errorHandling';
import { getAuthToken } from '../utils/helper-functions';

/**
 * Shared request/response interceptors for axios instances.
 */
export const attachInterceptors = (client, { withAuth = true } = {}) => {
    client.interceptors.request.use(
        (config) => {
            if (withAuth) {
                const token = getAuthToken();
                if (token) {
                    config.headers = config.headers || {};
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    client.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;

            if (status === 401) {
                localStorage.removeItem('LoginToken');
                localStorage.removeItem('LogID');
                localStorage.removeItem('navState');
                if (window.location.pathname !== '/') {
                    window.location.assign('/');
                }
                error.globalNotified = true;
                return Promise.reject(error);
            }

            if (!isCancelledRequest(error) && !shouldSkipApiNotify(error)) {
                const message = getApiErrorMessage(error);
                if (message) {
                    emitGlobalError({ message, variant: 'error' });
                    error.globalNotified = true;
                }
            } else {
                error.globalNotified = true;
            }

            return Promise.reject(error);
        }
    );

    return client;
};

export default attachInterceptors;
